export default {
  acastGreyLighter: '#f8f8fc',
  acastGreyLight: '#ededed',
  acastGrey: '#8c8c8c',
  acastGreyAccent: '#646464',
  acastGreyDark: '#4f5157',
  acastBlack: '#0a0a21',
  acastBlackAccent: '#1f1f33',
  acastBlackMid: '#a1a1b2',
  acastBlackDefault: '#0d0d0d',
  acastGreyHover: '#d0dcea',
  acastGreyActive: '#c7d3e1',
  acastGreyCheckbox: '#bfbfbf',
  acastYellow: '#ffd140',
  acastYellowAccent: '#ffc214',
  acastYellowMid: '#ffebc2',
  acastYellowLight: '#fff7e5',
  acastOrangeAccent: '#e05806',
  acastOrangeLight: '#fff5f0',
  acastPurple: '#4040a8',
  acastPurpleAccent: '#2e2e80',
  acastPurpleMid: '#8585ff',
  acastPurpleGrey: '#f0f0f9',
  acastPurpleGreyAccent: '#dedef2',
  acastPurpleLight: '#ededf7',
  acastPurpleHover: '#343489',
  acastPurpleActive: '#29296b',
  acastPurpleFocus: '#8c8cd4',
  acastPurpleRadio: '#f0f0f9',
  acastPurpleMidLight: '#c2c1e4',
  acastRed: '#db2642',
  acastRedMid: '#f39ba2',
  acastRedHover: '#b81e35',
  acastRedActive: '#95182b',
  acastRedLight: '#fceef0',
  acastGreen: '#00a04f',
  acastGreenLight: '#e2fbef',
  acastGreenDark: '#007935',
  acastGreenMid: '#cae0d1',
  acastBlue: '#00aeef',
  acastBlueAccent: '#0092c7',
  acastBlueDarker: '#00749e',
  acastOrange: '#ff8236',
  acastPink: '#e85cb5',
  white: '#ffffff',
  black: '#000000',
};
